// A logo kept for after scrolling replaces the other logos once the editor scrolls, as on the published
// page. Each child of a region renders as one div, in order.
export function brandStateRules(element, id) {

  const initial = [];
  const scrolled = [];

  for (let index = 0; index < element.children.length; index++) {
    const child = element.children[index];
    if (child.type === 'ht-file') {
      const selector = '#' + id + ' > div:nth-of-type(' + (index + 1) + ')';
      if ((child.properties || {}).siteNavState === 'scrolled') {
        scrolled.push(selector);
      } else {
        initial.push('.site-nav-editor-scrolled ' + selector);
      }
    }
  }

  if (scrolled.length === 0) {
    return '';
  }

  const shown = scrolled.map(function prefix(selector) { return '.site-nav-editor-scrolled ' + selector; });
  let rules = scrolled.join(',') + '{display:none}' + shown.join(',') + '{display:block}';

  if (initial.length > 0) {
    rules += initial.join(',') + '{display:none}';
  }

  return rules;

}
